import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { HDRPreview } from '../hdr-preview';
import * as THREE from 'three';

@Component({
  selector: 'app-hdrthumbnail',
  templateUrl: './hdrthumbnail.component.html'
})
export class HDRThumbnailComponent implements OnInit {
  hdrPreview: HDRPreview;
  @ViewChild('container') container: ElementRef;
  @Input() imageBase: string;
  @Input() imageSrc: string;
  @Input() thumbHeight: number;

  ngOnInit(): void {
    this.hdrPreview = new HDRPreview(this.imageBase, this.imageSrc, this.thumbHeight, this.container, true);
    this.hdrPreview.update({});
  }
}



// WEBPACK FOOTER //
// ./src/app/hdrthumbnail/hdrthumbnail.component.ts